import * as types from '../constants/authConstants';
import { getClientMerchantPairs } from '../actions/authActions';
import Tenant from '../../util/tenant';
import _ from 'underscore';
import * as store from '../../api/localStore';

const initialState = {
  loggedIn: false,
  clientMerchantPairs: [],
  tenantPairs: [],
  userName: null,
  selectedClientId: '',
  selectedMerchantId: '',
  loginForm: { username: '', password: '' },
  confirmForm: { merchantId: '', },
  profile: {},
  reset: {},
  passwordReset: false,
  clients : []
};

const handleLogin = (auth) => {
  const { clients } = auth;
  const tenantName = Tenant.getName(); 

  let selection = { selectedClientId: tenantName };

  const pairs = getClientMerchantPairs(clients);
  const tenantPairs = getClientMerchantPairs(clients, tenantName);
  const merchantId = store.get('merchantId');
  
  if (auth.merchantId)
    selection.selectedMerchantId = auth.merchantId;
  else if (merchantId)
    selection.selectedMerchantId = merchantId;
  else if (tenantPairs.length == 1)
    selection.selectedMerchantId = tenantPairs[0].merchantId;
  
  const authState = {
    loggedIn: true,
    clientMerchantPairs: pairs,
    tenantPairs: tenantPairs,
    multiMerchant: tenantPairs.length > 1,
    clients: _.uniq(_.pluck(pairs, "clientId")),
    merchantId: auth.merchantId,
    userName: auth.userName,
    ...selection
  };

  if (selection.selectedMerchantId)
    store.set('merchantId', selection.selectedMerchantId);
  
  store.set('token', JSON.stringify(auth));

  return authState;
};

const handleLogout = () => {
  store.set('merchantId', '');
  store.set('token', '');

  return { loggedIn: false };
};

export default function Auth(state = initialState, action) {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
      return Object.assign({}, state, handleLogin(action.response));
    case types.ACCOUNT_CONFIRMATION_SUCCESS:
      return Object.assign({}, state, { reset: action.response });
    case types.LOAD_PROFILE_SUCCESS:
      return Object.assign({}, state, { profile: action.response });
    case types.SET_PASSWORD_SUCCCESS:
      return Object.assign({}, state, {});
    case types.LOGOUT_SUCCESS:
      return handleLogout();
    case types.PASSWORD_RESET_SENT:
      return Object.assign({}, state, { passwordReset: action.response });
    case types.GET_CLIENTS_SUCCESS:
      return Object.assign({}, state, { clients: _.uniq(action.response) });
    case types.SET_SELECTED_MERCHANT:
      store.set('merchantId', action.response.merchantId);
      return Object.assign({}, state, { selectedClientId: action.response.clientId, selectedMerchantId: action.response.merchantId });
    case types.CLEAR_SELECTED_MERCHANT:
      store.set('merchantId', '');
      return Object.assign({}, state, { selectedMerchantId: null });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/auth/reducers/auth.js